var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 263,
    viewBox: "0 0 262 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131 250.138C196.65 250.138 249.869 196.919 249.869 131.269C249.869 65.6199 196.65 12.4005 131 12.4005C65.3507 12.4005 12.1313 65.6199 12.1313 131.269C12.1313 196.919 65.3507 250.138 131 250.138Z",
    fill: "white",
    stroke: "black",
    strokeOpacity: 0.54,
    strokeWidth: 24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.173 78.0649L165.721 65.5166L179.051 78.8463L192.381 65.5166L204.929 78.0649L191.599 91.3947L204.929 104.724L192.381 117.273L179.051 103.943L165.721 117.273L153.173 104.724L166.503 91.3947L153.173 78.0649Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6216 78.0649L73.1698 65.5166L86.4996 78.8463L99.8294 65.5166L112.378 78.0649L99.048 91.3947L112.378 104.724L99.8294 117.273L86.4996 103.943L73.1698 117.273L60.6216 104.724L73.9513 91.3947L60.6216 78.0649Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2144 158.468H171.786V175.25H90.2144V158.468Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no-results.4ac41525289e6bb695d5ee71160d6cb3.svg";
export { ForwardRef as ReactComponent };